import { useState } from 'react'

import { ConfirmDialog } from 'src/shared/components/ui/popups/confirm-dialog'
import { cn } from 'src/shared/utils/cn'
interface TextWithLinksProps {
  text: string
  className?: string
  dark?: boolean
  onClick?: (e: React.MouseEvent) => void
}

const TextWithLinks = ({ text, className, onClick, dark }: TextWithLinksProps) => {
  const [linkToConfirm, setLinkToConfirm] = useState<string | null>(null)
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]+)/g

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    e.stopPropagation()
    setLinkToConfirm(href)
  }

  const handleConfirmNavigation = () => {
    if (linkToConfirm) {
      window.open(linkToConfirm, '_blank', 'noopener,noreferrer')
      setLinkToConfirm(null)
    }
  }

  const parts = text.split(urlRegex)

  return (
    <>
      <ConfirmDialog
        open={Boolean(linkToConfirm)}
        onOpenChange={() => setLinkToConfirm(null)}
        title="External Link"
        description={`You're about to visit: ${linkToConfirm}`}
        onConfirm={handleConfirmNavigation}
      />
      <span className={cn('whitespace-pre-wrap text-wrap', className)} onClick={onClick}>
        {parts.map((part, index) => {
          if (!part) return null

          if (urlRegex.test(part)) {
            const href = part.startsWith('www.') ? `https://${part}` : part
            return (
              <a
                key={index}
                href={href}
                className={cn('text-secondary hover:underline', dark && 'text-secondaryInverse')}
                onClick={(e) => handleLinkClick(e, href)}
              >
                {part}
              </a>
            )
          }

          return <span key={index}>{part}</span>
        })}
      </span>
    </>
  )
}

export { TextWithLinks }
export type { TextWithLinksProps }
